module.exports = __webpack_public_path__ + "img/icon-phone-handle.8e6a361c.svg";